import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { useStore, selectByCategory } from '@/utils/store';
import { CATEGORY_COLORS } from '@/utils/format';
import { useCurrency } from '@/hooks/useCurrency';

export default function ExpenseBreakdownChart() {
  const { t } = useTranslation();
  const { format: formatCurrency } = useCurrency();
  const byCategory = useStore(selectByCategory);

  const data = byCategory.map(({ category, amount }) => ({
    name: t(`categories.${category}`),
    value: amount,
    color: CATEGORY_COLORS[category] || '#94a3b8',
  }));

  if (data.length === 0) return null;

  return (
    <div className="card">
      <h2 className="font-semibold text-gray-900 dark:text-white mb-4">
        {t('dashboard.spendingByCategory')}
      </h2>
      <ResponsiveContainer width="100%" height={220}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={55}
            outerRadius={90}
            paddingAngle={3}
            dataKey="value"
          >
            {data.map((entry, i) => (
              <Cell key={i} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) => formatCurrency(value)}
            contentStyle={{
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              fontSize: '12px',
            }}
          />
        </PieChart>
      </ResponsiveContainer>
      {/* Legend */}
      <div className="flex flex-wrap gap-3 justify-center mt-2">
        {data.map((d) => (
          <div key={d.name} className="flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-400">
            <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: d.color }} />
            {d.name}
          </div>
        ))}
      </div>
    </div>
  );
}
